(function(){
  'use strict';
  var SP = 692421788011;   // ← JP: PRO_MO_BUNDLE_SP (15-day trial)
  var _busy = false;

  function reload() { window.location.reload(); }

  function api(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r) { return r.json(); });
  }

  function init() {
    var wrapper = document.getElementById('cart-upsell-monthly-wrapper');
    if (!wrapper) return;

    var proVid = wrapper.getAttribute('data-pro-variant');
    var memVid = wrapper.getAttribute('data-mem-vid');
    var memKey = wrapper.getAttribute('data-mem-key');
    var isAdded = wrapper.getAttribute('data-mem-state') === 'added';

    var promoSource = document.getElementById('cum-promo-source');
    var promoHTML = promoSource ? promoSource.innerHTML : '✨ 15日間無料でお試しいただけます！';

    var addBtn = document.getElementById('cum-add-btn');
    if (addBtn) {
      addBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (_busy) return; _busy = true;
        addBtn.textContent = '追加中...';
        api('/cart/add.js', { items: [{ id: Number(proVid), quantity: 1, selling_plan: SP, properties: {'Offer': '15 Days Free Trial'} }] })
          .then(reload).catch(function(){ _busy=false; addBtn.textContent='無料トライアル'; });
      });
    }

    if (isAdded) {
      var modal = document.getElementById('cum-modal');
      if (modal && modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
      wrapper.style.display = 'none';

      var targetRow = null;
      document.querySelectorAll('.cart-items__table-row, .cart-item').forEach(function(row) {
        var isMatch = false;
        var varInputs = row.querySelectorAll('input[name="id"], [data-variant-id]');
        varInputs.forEach(function(inp) {
          if (String(inp.value) === String(memVid) || inp.getAttribute('data-variant-id') === String(memVid)) isMatch = true;
        });
        var key = row.getAttribute('data-key') || '';
        if (key.indexOf(String(memVid)) !== -1) isMatch = true;
        if (isMatch) targetRow = row;
      });

      if (targetRow) {
        var qtyWrapper = targetRow.querySelector('.quantity-selector-wrapper, .cart-items__qty, cart-remove-button');
        if (qtyWrapper) qtyWrapper.style.display = 'none';

        var nativeRemove = targetRow.querySelector('button.cart-items__remove, .cart-remove-button');
        if (nativeRemove) nativeRemove.style.display = 'none';

        var priceTd = targetRow.querySelector('.cart-items__price, .cart-item__price, .cart-item__totals, [headers="CartItem-Price"]');

        if (priceTd && !priceTd.querySelector('.cum-row-actions')) {
          var actions = document.createElement('div');
          actions.className = 'cum-row-actions';
          actions.style.cssText = 'display:flex; align-items:center; justify-content:flex-end; gap:12px; margin-top:6px; flex-wrap:wrap; width:100%;';

          var removeLink = document.createElement('button');
          removeLink.type = 'button';
          removeLink.textContent = '削除';
          removeLink.style.cssText = 'background:none; border:none; cursor:pointer; text-decoration:underline; font-size:14px; color:#666; padding:0; font-family:inherit;';

          var editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.textContent = '変更';
          editBtn.style.cssText = 'background:#000; color:#fff; border:none; cursor:pointer; padding:6px 18px; border-radius:6px; font-size:14px; font-weight:bold; font-family:inherit;';

          actions.appendChild(removeLink);
          actions.appendChild(editBtn);
          priceTd.appendChild(actions);

          var promoDiv = document.createElement('div');
          promoDiv.style.cssText = 'font-size: 12px; color: #000; margin-top: 8px; text-align: right; width: 100%;';
          promoDiv.innerHTML = promoHTML;
          priceTd.appendChild(promoDiv);

          removeLink.addEventListener('click', function(e) {
            e.preventDefault();
            if (_busy) return; _busy = true;
            api('/cart/change.js', { id: memKey, quantity: 0 }).then(reload);
          });

          editBtn.addEventListener('click', function(e) {
            e.preventDefault();
            document.getElementById('cum-modal').removeAttribute('hidden');
          });
        }
      }
    }

    var confirmBtn = document.getElementById('cum-confirm-btn');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        var selectedRadio = document.querySelector('input[name="cum_plan"]:checked');
        if (!selectedRadio) return;
        var selected = selectedRadio.value;
        if (selected == memVid) {
          document.getElementById('cum-modal').setAttribute('hidden', '');
          return;
        }
        if (_busy) return; _busy = true;
        confirmBtn.textContent = '切り替え中...';
        api('/cart/change.js', { id: memKey, quantity: 0 }).then(function() {
          var sp = selectedRadio.getAttribute('data-sp');
          var cartItem = { id: Number(selected), quantity: 1 };
          if (sp) cartItem.selling_plan = Number(sp);
          return api('/cart/add.js', { items: [cartItem] });
        }).then(reload).catch(function(){ _busy=false; confirmBtn.textContent='確認'; });
      });

      var _segM = document.getElementById('cum-seg-monthly');
      var _segY = document.getElementById('cum-seg-yearly');
      var _segCtrl = document.querySelector('#cum-modal .cum-seg-ctrl');
      if (_segCtrl) {
        _segCtrl.style.setProperty('display', 'inline-flex', 'important');
        _segCtrl.style.setProperty('background', '#f0f0f0', 'important');
        _segCtrl.style.setProperty('border-radius', '100px', 'important');
        _segCtrl.style.setProperty('padding', '4px', 'important');
      }
      var _segRow = document.querySelector('#cum-modal .cum-modal-toggle-row');
      if (_segRow) {
        _segRow.style.setProperty('display', 'flex', 'important');
        _segRow.style.setProperty('justify-content', 'center', 'important');
        _segRow.style.setProperty('margin', '12px 0 20px', 'important');
      }
      function _styleSegBtn(btn, active) {
        if (!btn) return;
        [['padding','10px 28px'],['border','none'],['border-radius','100px'],
         ['background', active ? '#fff' : 'transparent'],
         ['font-size','14px'],['font-weight', active ? '600' : '500'],
         ['color', active ? '#111' : '#888'],['cursor','pointer'],
         ['line-height','1'],['-webkit-appearance','none'],['appearance','none'],
         ['display','inline-flex'],['align-items','center'],['white-space','nowrap'],
         ['box-shadow', active ? '0 1px 6px rgba(0,0,0,0.13)' : 'none']
        ].forEach(function(p){ btn.style.setProperty(p[0], p[1], 'important'); });
      }
      _styleSegBtn(_segM, true);
      _styleSegBtn(_segY, false);
      function _cumSwitchBilling(yr) {
        var mDiv = document.getElementById('cum-plans-monthly');
        var yDiv = document.getElementById('cum-plans-yearly');
        if (mDiv) mDiv.style.display = yr ? 'none' : 'grid';
        if (yDiv) yDiv.style.display = yr ? 'grid' : 'none';
        var first = document.querySelector('#cum-plans-' + (yr ? 'yearly' : 'monthly') + ' input[name="cum_plan"]');
        if (first) first.checked = true;
        _styleSegBtn(_segM, !yr);
        _styleSegBtn(_segY, yr);
      }
      if (_segM) _segM.addEventListener('click', function() { _cumSwitchBilling(false); });
      if (_segY) _segY.addEventListener('click', function() { _cumSwitchBilling(true); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ===== RECOMMENDATIONS: Fix Add To Cart for subscription products =====
(function(){
  var AI_NOTE_PID       = 14942213570923;  // JP AI Note product_id
  var PRO_MO_BUNDLE_VID = 53130336108907;  // JP Pro Monthly Bundle (15-day trial)
  var PRO_MO_BUNDLE_SP  = 692421788011;
  var PRO_MO_REG_VID    = 53130336141675;  // JP Pro Monthly Regular
  var PRO_MO_REG_SP     = 692412088683;

  // JP variant IDs → JP selling_plan IDs
  var SP_MAP = {
    53106146574699: 692412088683, // Unlimited Monthly
    53130336141675: 692412088683, // Pro Monthly Regular (also in PRO_MO_VIDS)
    53078669427051: 692400324971, // Pro Annual Bundle
    53078669394283: 692400324971, // Pro Annual Regular
    53078671524203: 692400324971, // Unlimited Annual Bundle
    53078671491435: 692400324971  // Unlimited Annual Regular
  };

  var PRO_MO_VIDS = [PRO_MO_BUNDLE_VID, PRO_MO_REG_VID];

  function aiNoteInCart() {
    return fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(c){
        return (c.items||[]).some(function(i){ return i.product_id === AI_NOTE_PID; });
      });
  }

  function cartAdd(vid, sp, btn, origTxt) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({items:[{id: vid, quantity: 1, selling_plan: sp}]})
    }).then(function(r){
      if(!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function(){
      window.location.reload();
    }).catch(function(){
      if(btn){ btn.disabled = false; btn.textContent = origTxt; }
    });
  }

  function patchForm(form) {
    if(form._cuRecFixed) return;
    form._cuRecFixed = true;
    form.addEventListener('submit', function(e) {
      var inp = form.querySelector('input[name="id"]');
      if(!inp) return;
      var vid = Number(inp.value);
      var staticSp = SP_MAP[vid];
      var isProMo  = PRO_MO_VIDS.indexOf(vid) !== -1;
      if(!staticSp && !isProMo) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = form.querySelector('button[type="submit"],button');
      var origTxt = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = '追加中...'; }

      if(isProMo) {
        aiNoteInCart().then(function(hasNote) {
          if(hasNote) {
            cartAdd(PRO_MO_BUNDLE_VID, PRO_MO_BUNDLE_SP, btn, origTxt);
          } else {
            cartAdd(PRO_MO_REG_VID, PRO_MO_REG_SP, btn, origTxt);
          }
        });
      } else {
        cartAdd(vid, staticSp, btn, origTxt);
      }
    });
  }

  function scanForms(root) {
    (root||document).querySelectorAll('form[action*="cart/add"]').forEach(patchForm);
  }

  var obs = new MutationObserver(function(muts) {
    muts.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if(n.nodeType === 1) scanForms(n);
      });
    });
  });

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scanForms();
      obs.observe(document.body, {childList:true, subtree:true});
    });
  } else {
    scanForms();
    obs.observe(document.body, {childList:true, subtree:true});
  }
})();

// ===== style toggle switch =====
(function(){
  function apply(yr){
    var mPlans = document.getElementById('cum-plans-monthly');
    var yPlans = document.getElementById('cum-plans-yearly');
    var mLbl = document.getElementById('cum-seg-monthly');
    var yLbl = document.getElementById('cum-seg-yearly');
    var sw = document.getElementById('cum-toggle-switch');
    var knob = document.getElementById('cum-toggle-knob');
    if (mPlans) mPlans.style.display = yr ? 'none' : '';
    if (yPlans) yPlans.style.display = yr ? '' : 'none';
    if (mLbl) { mLbl.style.fontWeight = yr ? '500' : '700'; mLbl.style.color = yr ? '#888' : '#111'; }
    if (yLbl) { yLbl.style.fontWeight = yr ? '700' : '500'; yLbl.style.color = yr ? '#111' : '#888'; }
    if (sw) { sw.style.background = yr ? '#8b5cf6' : '#d1d5db'; sw.setAttribute('aria-checked', yr ? 'true' : 'false'); }
    if (knob) { knob.style.left = yr ? '27px' : '3px'; }
  }
  document.body.addEventListener('click', function(e){
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('#cum-seg-monthly, #cum-seg-yearly, #cum-toggle-switch, #cum-toggle-knob');
    if (!t) return;
    var yr;
    if (t.id === 'cum-seg-monthly') yr = false;
    else if (t.id === 'cum-seg-yearly') yr = true;
    else {
      var sw = document.getElementById('cum-toggle-switch');
      yr = sw && sw.getAttribute('aria-checked') !== 'true';
    }
    apply(yr);
  });
})();